'use client';

// TODO #22309: unify with EventTimelinePremiumSkeleton — diverges in props (`data-variant` required here), sizing (variant-based absolute positioning vs theme-derived height), and styled context. On unification, prefer the timeline's theme-derived sizing.
import _extends from "@babel/runtime/helpers/esm/extends";
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { useEventCalendarStyledContext } from "../../../event-calendar/EventCalendarStyledContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const EventSkeletonRoot = styled(Skeleton, {
  name: 'MuiEventCalendar',
  slot: 'EventSkeleton'
})({
  opacity: 0.5,
  '&[data-variant="time-column"]': {
    position: 'absolute',
    left: 0,
    right: 12,
    top: 0,
    height: '100%',
    borderRadius: 0
  },
  '&[data-variant="day-grid"]': {
    height: 18
  },
  '&[data-variant="agenda"]': {
    height: 28
  }
});
export function EventSkeleton(props) {
  const {
    classes
  } = useEventCalendarStyledContext();
  return /*#__PURE__*/_jsx(EventSkeletonRoot, _extends({
    variant: "rounded",
    animation: "wave",
    "aria-hidden": true
  }, props, {
    className: clsx(classes.eventSkeleton, props.className)
  }));
}